import { equals, find } from '@execonline-inc/collections';
import { FieldDescription, FieldValue, SelectFormField, StringFormField } from '../Types';

export const stringInputOptionLabel = (stringFormField: StringFormField) =>
  stringFormField.label.map((label) => label.text).getOrElseValue(stringFormField.name);

export const convertToFieldValue = (label: string, value: string): FieldValue => ({
  label,
  value,
});

export const inputValue = (stringFormField: StringFormField, fieldValue: FieldValue[]) =>
  find((v) => equals(v.label, stringInputOptionLabel(stringFormField)), fieldValue)
    .map((v) => v.value)
    .getOrElseValue('');

export const formatInputValue = (
  stringFormField: StringFormField,
  stringFieldValue: string,
): FieldValue => ({
  label: stringInputOptionLabel(stringFormField),
  value: stringFieldValue,
});

// DVLP-7754 / DVLP-7781: rebuild the +FieldValue[]+ selection components
// consume from the server-supplied +fieldDescription.value+ prefill
// (backend hydrates this from +AttributableAttribute+). String fields
// carry a single scalar; multi-select fields carry an array of option
// value strings that must be matched back to the field's options to
// recover the +label+. The embedded string-option variant has a
// +Maybe<AlreadyTranslatedText>+ label rather than a plain string, so
// narrow with +typeof label === 'string'+ before emitting.
export const multiSelectPrefillSeed = (selectField: SelectFormField): FieldValue[] =>
  selectField.value.flatMap((v) => {
    const option = selectField.options.find(
      (o) => 'value' in o && typeof o.value === 'string' && o.value === v,
    );
    return option &&
      'label' in option &&
      typeof option.label === 'string' &&
      typeof option.value === 'string'
      ? [convertToFieldValue(option.label, option.value)]
      : [];
  });

export const fieldDescriptionPrefillSeed = (fieldDescription: FieldDescription): FieldValue[] => {
  switch (fieldDescription.kind) {
    case 'string':
      return fieldDescription.value !== ''
        ? [convertToFieldValue(stringInputOptionLabel(fieldDescription), fieldDescription.value)]
        : [];
    case 'multiple-selection':
      return multiSelectPrefillSeed(fieldDescription);
  }
};
